import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import {
  COACH_OKR_PLAN,
  COACH_OKR_PLAN_CHAT,
  COACH_OKR_PLAN_REPORT,
  COACH_OKR_PLAN_REVIEW,
  COACH_OKR_PLANS_BASE,
  COACH_OKR_PLANS_COMPANY,
} from "../../../data/RouteUrls";
import OpcShell from "./_shared/OpcShell/OpcShell";
import OkrPlansCoachDashboard from "./OkrPlansCoachDashboard/OkrPlansCoachDashboard";
import OkrPlansCoachCompany from "./OkrPlansCoachCompany/OkrPlansCoachCompany";
import OkrPlansCoachPlan from "./OkrPlansCoachPlan/OkrPlansCoachPlan";
import OkrPlansCoachCheckIn from "./OkrPlansCoachCheckIn/OkrPlansCoachCheckIn";
import OkrPlansCoachReview from "./OkrPlansCoachReview/OkrPlansCoachReview";
import OkrPlansCoachChat from "./OkrPlansCoachChat/OkrPlansCoachChat";

// ═══════════════════════════════════════════════════════════════════════════
// OKR Plans (coach) — every route under `/coach-panel/okr-plans`
// (OKR_PLANS_COACH.md §8.2, §9), all live on the API inside `OpcShell`.
// ═══════════════════════════════════════════════════════════════════════════

const OkrPlansCoach = () => (
  <OpcShell>
    <Switch>
      <Route path={COACH_OKR_PLAN_REPORT} component={OkrPlansCoachCheckIn} />
      <Route path={COACH_OKR_PLAN_REVIEW} component={OkrPlansCoachReview} />
      <Route path={COACH_OKR_PLAN_CHAT} component={OkrPlansCoachChat} />
      <Route path={COACH_OKR_PLAN} component={OkrPlansCoachPlan} />
      <Route path={COACH_OKR_PLANS_COMPANY} component={OkrPlansCoachCompany} />
      <Route
        exact
        path={COACH_OKR_PLANS_BASE}
        component={OkrPlansCoachDashboard}
      />
      <Redirect to={COACH_OKR_PLANS_BASE} />
    </Switch>
  </OpcShell>
);

export default OkrPlansCoach;
